import React, { Fragment } from 'react'
import YardsDowns from './YardsDowns.jsx'
import Score from './Score.jsx'
import Possession from './Possession.jsx'
import Submit from './Submit'
import { Divider } from 'semantic-ui-react'
import PropTypes from 'prop-types'

const StatsUpdate = ({
  history,
  location: { state },
  match: {
    params: { gameId: id }
  }
}) => {
  return (
    <Fragment>
      <YardsDowns />
      <Score />
      <Possession />
      <Divider />
      <Submit />
    </Fragment>
  )
}

StatsUpdate.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
}

export default StatsUpdate



// WEBPACK FOOTER //
// ./src/components/Controller/StatsUpdate.jsx